
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  



    <div class="row">
      <div class="d-block d-md-none">
      <b-button variant="primary" @click="showSidebar = true"> Genres </b-button>
        <b-sidebar id="sidebar" title="Filter By Genres" :visible="showSidebar" @hidden="showSidebar = false" backdrop >
        <div>
          <div v-for="item in genres" :key="item.id" class="mb-1">
            <router-link :to="{ path: '/genre', query: { id: item.id, name:item.name }}" style="font-size: 13px;" class="text-dark">
              <div class="card shadow-lg my-1">
              <div class="card-body py-2">
                <h6><i class="mdi mdi-arrow-right"></i>  {{ item.name }} </h6>
              </div>
              </div>
            </router-link>
          </div>
          <b-button variant="secondary" @click="showSidebar = false"> Close</b-button>
        </div>
      </b-sidebar>
    </div>

      <div class="col-lg-3 col-sm-3 d-none d-lg-block ">
          <h4 class="card-title mb-1">Filter By Genres</h4>
          <div v-for="item in genres" :key="item.id" class="mb-1">
              <router-link :to="{ path: '/genre', query: { id: item.id, name:item.name }}" style="font-size: 13px;" class="text-dark">
                <div class="card shadow-lg my-1">
                <div class="card-body py-2">
                  <h6><i class="mdi mdi-arrow-right"></i>  {{ item.name }} </h6>
                </div>
                </div>
              </router-link>
          </div>
        </div>
      <div class="col-lg-9 col-sm-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6"><div class="mt-2"></div></div>
          <div class="col-lg-8 col-sm-6">
            <form class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
              <div class="search-box me-2">
                <div class="position-relative">
                  <input type="search"  class="form-control border-2" placeholder="Search..." @input="filterMovie($event)"/>
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
              <ul class="nav nav-pills product-view-nav">
                <li class="nav-item"><a class="nav-link active" href="javascript: void(0);"><i class="bx bx-grid-alt"></i></a></li>
                <li class="nav-item"><a class="nav-link" href="javascript: void(0);"><i class="bx bx-list-ul"></i></a></li>
              </ul>
            </form>
          </div>
        </div>
        <div class="row">
          <div v-for="data in movies" :key="data.id" class="col-md-3 col-6">
            <div class="card shadow-lg">
              <div class="card-body p-2">
                <div class="product-img position-relative">
                  <div class="product-ribbon"><span class="bg-primary text-white p-2 rounded-2">{{ data.rating }}</span></div>
                  <router-link :to="{ path: '/movie', query: { id: data.movie_id }}">
                    <img :src="getFiles(data.photo)" class="img-fluid mx-auto d-block"/>
                  </router-link>
                </div>
                <div class="mt-2">
                  <div>
                    <h5 class="mb-1"><b>{{ data.name }}</b></h5>
                    <i><b> {{(data.genre.name) }}</b></i>
                  </div>
                  <div>
                    <router-link :to="{ path: '/movie', query: { id: data.movie_id }}">
                      <b-button size="sm" style="background: black;"> View Details </b-button>
                    </router-link>
                  </div>
              </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-lg-12">
            <b-pagination
              v-if="movies.length > 0" class="justify-content-center" v-model="currentPage" :total-rows="movies.length" :per-page="6" ></b-pagination>
          </div>
        </div> -->

        <div v-if="movies.length<=0" class="text-center p-4">
          <i class="fas fa-video fa-4x"></i>
          No Movies Found<br><br>
          <router-link tag="a" to="/movies" class="btn btn-sm btn-success" >View Movies</router-link>
      </div>
      </div>
    </div>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import simplebar from "simplebar-vue";

import { movieMethods, movieComputed, genreMethods, genreComputed } from "@/state/helpers";

export default {
  page: {
    title: "Movies",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Movies",
      items: [
        {text: "Home",href: "/",},
        {text: "Movies",active: true, },
      ],
      sliderPrice: 150000,
      currentPage: 1,
      showSidebar:false,
    };
  },
  mounted() {
    this.fetchMovies();
    this.fetchGenres();
  },
  computed: {
    ...movieComputed,
    ...genreComputed,
  },
  methods: {
    ...movieMethods,
    ...genreMethods,
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"movies/"+name;
      return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    valuechange() {
      this.filterPrice({search:this.sliderPrice});
    },
    filterMovie(e) {
      const search = e.target.value;
      this.filterMovies({search:search});
    },
    FindByCategory(category){
      this.filterProductsByCategory({category:category});
    },
  },
};
</script>
<!-- <style scoped>
.card img {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out;
}

.card:hover img {
  transform: scale(1.1);
}
</style> -->